var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useRef } from 'react';
import { cx, css as emotionCss } from 'emotion';
import { SegmentLegendWrapper as Component, SegmentLegendTitle, SegmentLegendLabel } from './ProgressBar.styled';
import { getAutomation, getDebug, useCitrusDebug } from '@citrus/runtime';
import { isNotNullOrEmpty } from '@pcty/utils';
import { getSegmentLabelColor } from './private/_utils';
import { useTheme } from '@citrus/user';
var VERSION = '4.6.0';
var SegmentLegend = function (_a) {
    var _b;
    var automationId = _a.automationId, className = _a.className, color = _a.color, css = _a.css, label = _a.label, _c = _a.small, small = _c === void 0 ? false : _c, value = _a.value, width = _a.width, _d = _a.__count, __count = _d === void 0 ? 0 : _d, 
    // FIXME
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _e = _a.__first, 
    // FIXME
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    __first = _e === void 0 ? false : _e, 
    // FIXME
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _f = _a.__last, 
    // FIXME
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    __last = _f === void 0 ? false : _f, _g = _a.__TYPE, TYPE = _g === void 0 ? 'SegmentLegend' : _g, other = __rest(_a, ["automationId", "className", "color", "css", "label", "small", "value", "width", "__count", "__first", "__last", "__TYPE"]);
    var debug = useCitrusDebug();
    var itemRef = useRef(null);
    var isCitron = useTheme().citrus2022;
    var classes = cx((_b = {},
        _b[emotionCss(css)] = isNotNullOrEmpty(css),
        _b), className || '');
    // __count is fed in from ProgressBarSegments but defaults to 100% if not specified
    var autoWidth = __count > 0 ? 100 / __count : 100;
    // if width is specified, just use it instead of autoWidth
    var styles = isNotNullOrEmpty(width) ? { width: width } : { width: "".concat(autoWidth, "%") };
    var valueColor = getSegmentLabelColor(color, isCitron);
    var replacedLabel = '';
    if (typeof label === 'string') {
        var valueTag = '{$value}';
        var valueSpan = "<span style=\"color: ".concat(valueColor, "\">").concat(value, "</span>");
        replacedLabel =
            isNotNullOrEmpty(label) && isNotNullOrEmpty(value) ? label.replace(valueTag, valueSpan) : label;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Component, __assign({ className: classes, ref: itemRef, style: styles }, other, getAutomation(automationId), getDebug(debug, TYPE, VERSION)),
            !small && React.createElement(SegmentLegendTitle, { style: { color: valueColor } }, value + '%'),
            isNotNullOrEmpty(replacedLabel) ? (React.createElement(SegmentLegendLabel, { dangerouslySetInnerHTML: { __html: replacedLabel } })) : (React.createElement(SegmentLegendLabel, null, label)))));
};
SegmentLegend.defaultProps = {
    __TYPE: 'SegmentLegend',
};
export default SegmentLegend;
